
/**
 * 통화 코드
 */
export type GetCourseDraftById200PriceCurrency = typeof GetCourseDraftById200PriceCurrency[keyof typeof GetCourseDraftById200PriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDraftById200PriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
